import { EventCategory } from '@lendi/analytics-web';

import { getPageNameFromUrlPath } from '../getPageNameFromPath';
import { lendiAnalytics } from './analytics';

// Page event
export function pageTracking(analytics: ReturnType<typeof lendiAnalytics>) {
  analytics.trackPage(EventCategory.FUNNELS, getPageNameFromUrlPath(window.location.pathname));
}
